<div class="booking-filter-container" [formGroup]="bookingForm" *ngIf="bookingForm && !isBookingOverview">
  <mat-form-field>
    <mat-label>Date range</mat-label>
    <span matPrefix (click)="openDatePicker()">
      <img src="../../../assets/images/icons-kpi-dashboard/shooting-schedule.png" alt="Date Icon" class="date-icon" />
    </span>
    <mat-date-range-input [rangePicker]="bookingPicker" [min]="minDate" [max]="maxDate" (click)="openDatePicker()">
      <input matStartDate placeholder="Start date" formControlName="startDate" aria-label="Start Date"/>
      <input matEndDate placeholder="End date" formControlName="endDate" (dateC`hange)="onDateRangeChange()" aria-label="End Date"
        (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" />
    </mat-date-range-input>
    <mat-date-range-picker #bookingPicker></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field *ngIf="showServiceType">
    <mat-label>Category</mat-label>
    <span matPrefix>
      <img src="../../../assets/images/icons-kpi-dashboard/customer-service.png" alt="Service Icon"
        class="furniture-icon" />
    </span>
    <mat-select formControlName="bookingCategory" multiple (selectionChange)="onCategorySelectionChange($event)"
      [compareWith]="compare">
      <mat-option *ngFor="let category of bCategories" [value]="category.id">
        {{ category.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="showStore">
    <mat-label>Store</mat-label>
    <span matPrefix>
      <img src="../../../assets/images/icons-kpi-dashboard/store-icon.png" alt="Booking Store" class="furniture-icon" />
    </span>
    <mat-select formControlName="bookingStore" (selectionChange)="onStoreSelectionChange($event)"
      [compareWith]="compareStores" [disabled]="isStoresLoading" [multiple]="true" #multiSelect>
      <mat-option *ngIf="!isStoresLoading"  (click)="$event.stopPropagation()">
        <ngx-mat-select-search placeholderLabel="Search stores..."  (input)="filterStores($event)" [value]="storeSearchTerm"></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let store of filteredStores" [value]="store.storeId">
        {{ store.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>


  <mat-form-field>
    <mat-label>Status</mat-label>
    <span matPrefix>
      <img src="../../../assets/images/icons-kpi-dashboard/status-icon.png" alt="Status Icon" class="furniture-icon" />
    </span>
    <mat-select formControlName="bookingStatus" multiple (selectionChange)="onStatusSelectionChange($event)"
      [compareWith]="compare">
      <mat-option *ngFor="let category of bStatuses" [value]="category.id">
        {{ category.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-slide-toggle *ngIf="companyId === 4" class="toggleBtn" formControlName="enableExecutionDate"
    (change)="isExecutionDateEnabled($event.checked)">{{isExecutionDate ? 'Switch filter back to Creation Date' :
    'Switch filter to Execution Date' }}</mat-slide-toggle>
</div>

<!-- Data is available -->
<div class="example-table-container" *ngIf="!isBookingOverview">
  <table mat-table [dataSource]="sortedData" matSort (matSortChange)="handleSortChange($event)">
    <!-- Number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disabled="true">
        No.
      </th>
      <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
    </ng-container>

    <!-- Created Date Column -->
    <ng-container matColumnDef="receiveDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Creation Date</th>
      <td mat-cell *matCellDef="let row">{{ row.receiveDate }}</td>
    </ng-container>

    <!-- Service Column -->
    <ng-container matColumnDef="serviceType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Service Type</th>
      <td mat-cell *matCellDef="let row">
        <a mat-button (click)="overview(row.taskId)" class="service-type">{{
          row.serviceType
          }}</a>
      </td>
    </ng-container>

    <!-- Task Id Column -->
    <ng-container matColumnDef="taskId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Task Id</th>
      <td mat-cell *matCellDef="let row">{{ row.taskId }}</td>
    </ng-container>

    <!-- City Column -->
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Post code</th>
      <td mat-cell *matCellDef="let row">{{ row.city }}</td>
    </ng-container>

    <!-- Store Column -->
    <ng-container matColumnDef="store">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Store</th>
      <td mat-cell *matCellDef="let row">{{ row.store }}</td>
    </ng-container>

    <!-- Execution Date Column -->
    <ng-container matColumnDef="executionDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Execution Date</th>
      <td mat-cell *matCellDef="let row">{{ row.executionDate }}</td>
    </ng-container>

    <!-- Lead Time Column -->
    <ng-container matColumnDef="leadTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead Time</th>
      <td mat-cell *matCellDef="let row">
        {{ row.leadTime | currency : "EUR" : "" : "1.2-2" : "de" }} days
      </td>
    </ng-container>

    <!-- Order Value Column -->
    <ng-container matColumnDef="orderValue">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Order Value (incl. VAT)
      </th>
      <td mat-cell *matCellDef="let row">&#8364; {{ row.orderValue }}</td>
    </ng-container>

    <!-- leadFee Column -->
    <ng-container matColumnDef="leadFee">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Lead Fee (incl. VAT)
      </th>
      <td mat-cell *matCellDef="let row">
        &#8364; {{ row.leadFee | currency : "EUR" : "" : "1.2-2" : "de" }}
      </td>
    </ng-container>

    <!-- status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let row">
        <div [ngClass]="getStatusClass(row.statusName)">
          {{ row.statusName }}
          <span class="img-span">
            <img [src]="getStatusIcon(row?.statusName ?? '')" alt="status-icon" class="status-icon" />
          </span>
        </div>
      </td>
    </ng-container>

    <!-- hasWarrantyRequest Column -->
    <ng-container matColumnDef="hasWarrantyRequest">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Warranty</th>
      <td mat-cell *matCellDef="let row">
        {{ row.hasWarrantyRequest ? "Yes" : "-" }}
      </td>
    </ng-container>

    <!-- Header Row and Data Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <div *ngIf="sortedData.length === 0">No Data Available</div>

  <!-- Paginator -->
  <mat-paginator [length]="resultsLength" [pageIndex]="currentPageIndex" [pageSize]="currentPageSize"
    [pageSizeOptions]="[20, 50, 100, 200, 500]" (page)="onPageChange($event)" aria-label="Select page of results"
    class="paginator">
  </mat-paginator>
</div>

<app-booking-overview *ngIf="isBookingOverview" [isLoading]="isLoading"
  (showBookingsData)="isBookingsData($event)"></app-booking-overview>